module.exports = __webpack_public_path__ + "img/益视说明书_04.b4085600.png";